import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import familyImg from "@/assets/family-new-1.jpeg";
import tripleImg from "@/assets/triple-room-preview.jpeg";
import economyImg from "@/assets/economy-room-1.jpeg";
import room4 from "@/assets/room-4.png";
import suiteLiving from "@/assets/suite-living.jpg";
import { useLanguage } from "@/i18n/LanguageContext";
import { useCmsContent } from "@/hooks/useCmsContent";
import { useRoomContent } from "@/hooks/useRoomContent";

const Rooms = () => {
  const { t } = useLanguage();
  const { get } = useCmsContent();
  const { getRoom } = useRoomContent();

  const roomDefs = [
    { type: "family", fallback: t.roomsPage.familyRoom, image: familyImg, link: "/rooms/family" },
    { type: "triple", fallback: t.roomsPage.tripleRoom, image: tripleImg, link: "/rooms/triple" },
    { type: "twin", fallback: t.roomsPage.twinRoom, image: economyImg, link: "/rooms/twin" },
    { type: "double", fallback: t.roomsPage.doubleRoom, image: room4, link: "/rooms/double" },
    { type: "suite", fallback: t.roomsPage.suite, image: suiteLiving, link: "/rooms/suite" },
  ];

  const rooms = roomDefs.map((r) => ({
    name: getRoom(r.type)?.title || r.fallback,
    image: r.image,
    link: r.link,
  }));

  return (
    <section id="rooms" className="hotel-section bg-background">
      <div className="hotel-container">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-16">
          <p className="hotel-caption text-accent mb-4">{get("rooms_page_caption") || t.roomsPage.caption}</p>
          <h2 className="hotel-heading text-foreground mb-6">{get("rooms_page_heading") || t.roomsPage.heading}</h2>
          <p className="hotel-body text-muted-foreground">{get("rooms_page_text") || t.roomsPage.text}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {rooms.map((room) => (
            <Link key={room.name} to={room.link} className="group flex flex-col bg-card rounded-lg overflow-hidden shadow-soft hover:shadow-elevated transition-all duration-500">
              <div className="relative h-52 sm:h-48 md:h-56 overflow-hidden">
                <img src={room.image} alt={room.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="flex flex-col flex-1 p-5 md:p-6">
                <h3 className="font-display text-lg md:text-xl font-light text-foreground mb-2">{room.name}</h3>
                <div className="w-10 h-px bg-accent mb-3 mt-auto" />
                <span className="inline-flex items-center gap-2 font-body text-xs text-accent uppercase tracking-[0.15em] font-medium group-hover:gap-3 transition-all duration-300 mt-2">
                  {get("rooms_page_learn_more") || t.roomsPage.learnMore}<ArrowRight className="w-3.5 h-3.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-10 md:mt-16 text-center">
          <p className="hotel-body text-muted-foreground mb-6">{get("rooms_page_book_direct") || t.roomsPage.bookDirect}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="hotel" size="lg" asChild><Link to="/contact">{get("rooms_page_inquire") || t.roomsPage.inquireNow}</Link></Button>
            <Button variant="outline" size="lg" asChild><Link to="/booking-policy">{get("rooms_page_booking_policy") || t.roomsPage.bookingPolicy}</Link></Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Rooms;
